import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Landing from "@/pages/Landing";
import ProductSheet from "@/pages/ProductSheet";
import ProductsIndex from "@/pages/ProductsIndex";
import Events from "@/pages/Events";
import Sustainability from "@/pages/Sustainability";
import WholesalePage from "@/pages/WholesalePage";
import CampusProgram from "@/pages/CampusProgram";
import OurCraft from "@/pages/OurCraft";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import InviteAccept from "@/pages/InviteAccept";
import CustomerPortal from "@/pages/CustomerPortal";
import AdminDashboard from "@/pages/AdminDashboard";
import ScrollToTop from "@/components/ScrollToTop";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import "@/App.css";

const Protected = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-leaf" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/portal" replace />;
  return children;
};

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/products" element={<ProductsIndex />} />
            <Route path="/products/:slug" element={<ProductSheet />} />
            <Route path="/events" element={<Events />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/wholesale" element={<WholesalePage />} />
            <Route path="/campus" element={<CampusProgram />} />
            <Route path="/craft" element={<OurCraft />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/invite/:token" element={<InviteAccept />} />
            <Route path="/portal" element={<Protected><CustomerPortal /></Protected>} />
            <Route path="/dashboard" element={<Protected adminOnly><AdminDashboard /></Protected>} />
            <Route path="/admin/leads" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
